import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App/';
import registerServiceWorker from './registerServiceWorker';
import { Router, Route } from 'react-router-dom'
import history from './history';
import { create } from 'jss';
import { StylesProvider, jssPreset } from '@material-ui/styles';
// import JssProvider from 'react-jss/lib/JssProvider';
// import { createGenerateClassName, jssPreset } from '@material-ui/core/styles';
// install styles from material-ui
import './bootstrap';

// Changing the CSS injection precedence (Material-UI - https://material-ui.com/customization/css-in-js/)
// const generateClassName = createGenerateClassName();
const jss = create({
  ...jssPreset(),
  // We define a custom insertion point that JSS will look for injecting the styles in the DOM.
  insertionPoint: document.getElementById('jss-insertion-point'),
});

ReactDOM.render(
  // <JssProvider jss={jss} generateClassName={generateClassName}>
  <StylesProvider jss={jss}>
    <Router history={history}>
      <div>
        <Route path="/" component={App}/>
      </div>
    </Router>
  </StylesProvider>,
  document.getElementById('root')
);

registerServiceWorker();


// import JssProvider from 'react-jss/lib/JssProvider';
// import { create } from 'jss';
// import { createGenerateClassName, jssPreset } from '@material-ui/core/styles';

// Changing the CSS injection precedence (Material-UI - https://material-ui.com/customization/css-in-js/)
// const generateClassName = createGenerateClassName();
// const jss = create({
//   ...jssPreset(),
//   // We define a custom insertion point that JSS will look for injecting the styles in the DOM.
//   insertionPoint: document.getElementById('jss-insertion-point'),
// });

// ReactDOM.render(
//   <JssProvider jss={jss} generateClassName={generateClassName}>
//     <Router history={history}>
//       <div>
//         <Route path="/" component={App}/>
//       </div>
//     </Router>
//   </JssProvider>,
//   document.getElementById('root'));
// registerServiceWorker();

